import { scrollytelling } from './initializeStats';
import { statsArticle } from './statsArticle';
import { inViewport } from './elementsInViewport';
import { linkStats, setStatElementCollector, shareStats } from './stats';
import { wideo } from './wideo';
import { menu } from './menu';
import { anchors } from './anchors';
//import { validateAndSubmitForm } from './validateAndSubmitForm';
//import { cssClasses } from './cssClasses';
//import { setMobileSrc } from './mobileSrc';
//import { debounce } from './helpers';

//setMobileSrc();
anchors();
statsArticle();
setStatElementCollector();
linkStats();
inViewport();
shareStats();
wideo();
menu();
//validateAndSubmitForm();
//cssClasses();

const changeSizesOnResize = () => {
  setMobileSrc();
};

//window.addEventListener('resize', debounce(changeSizesOnResize, 500));

window.addEventListener('beforeunload', scrollytelling.unloadData.bind(scrollytelling));
